import { getTranslatedMessage } from './messages';

const getErrorCode = (err: any): number => {
  if (err?.response?.status === 401) return 1001;
  if (err?.response?.status === 429) return 1003;

  const code = err?.response?.data?.code;
  return typeof code === 'number' ? code : 0;
};

// Cliente Beta da TIM: a BFF recusa a criação de sessão com CLIENTE_BLOQUEADO,
// sempre em 422. O 1005 em outro status não é bloqueio e segue como erro.
const CUSTOMER_BLOCKED = 1005;

export const isCustomerBlockedError = (err: any): boolean =>
  err?.response?.status === 422 && getErrorCode(err) === CUSTOMER_BLOCKED;

export const handleError = (
  err: any,
  showError: (error: { title?: string; message: string }) => void,
  onUnauthorized?: () => void,
) => {
  const code = getErrorCode(err);

  if (code === 1001 && onUnauthorized) {
    onUnauthorized();
    return;
  }

  const { title, message } = getTranslatedMessage(code);
  showError({ title, message });
};
